export default __webpack_public_path__ + "static/media/icon-cocoon.9bdacac6.png";